import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const { ContactCard: cardColors } = phoneColorKeys.Phone

const ContactCardParts = [
  'container',
  'labelContainer',
  'nameText',
  'numberText',
] as const

const helpers = createMultiStyleConfigHelpers(ContactCardParts)
export const ContactCard = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      height: '5.0625rem',
      width: 'full',
      paddingX: '0.75rem',
      paddingY: '0.5rem',
      gap: '0.5rem',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: 'solid 1px',
      position: 'relative',
      borderColor: cardColors.Container.BorderColor,
      _hover: {
        backgroundColor: cardColors.Container.Hover.Background,
        borderColor: cardColors.Container.Hover.BorderColor,
      },
      labelContainer: {
        flexDirection: 'column',
      },
      nameText: {
        textStyle: textStyleKeys.Body1,
      },
      numberText: {
        textStyle: textStyleKeys.Body3,
      },
    },
  },
})

export const useContactCardStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ContactCardParts>(
    getName({ ContactCard }),
    props,
  )
}
